import { render } from "./Tabulator.vue?vue&type=template&id=51ec922a"
import script from "./Tabulator.vue?vue&type=script&lang=js"
export * from "./Tabulator.vue?vue&type=script&lang=js"

import "./Tabulator.vue?vue&type=style&index=0&id=51ec922a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__